import { Button, Grid } from "@aws-amplify/ui-react";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import LocalizedStrings from "react-localization";
import { API, graphqlOperation } from "aws-amplify";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";

import ItemListCollection from "../ItemListCollection";
import { listRoles } from "graphql/queries";

export const RolesChoose = ({
  initRolesGranted = [],
  onChangeRolesGranted,
  resetValues,
}) => {
  const [rolesAvailable, setRolesAvailable] = useState([]);
  const [rolesGranted, setRolesGranted] = useState([]);
  const [rolesAvailableSelected, setRolesAvailableSelected] = useState([]);
  const [rolesGrantedSelected, setRolesGrantedSelected] = useState([]);
  const [keywordRolesGranted, setKeywordRolesGranted] = useState("");

  async function fetchRolesAvailable(keyword, diffRoles) {
    try {
      const rolesData = await API.graphql(
        graphqlOperation(listRoles, {
          limit: !keyword ? 20 : undefined,
          filter: keyword
            ? {
                or: [
                  {
                    name: { contains: keyword },
                  },
                ],
              }
            : {},
        })
      );
      const rolesItems = rolesData.data.listRoles.items;
      setRolesAvailable(
        rolesItems
          ?.filter(
            (roleItem) =>
              !diffRoles?.some((diffUs) => diffUs.id === roleItem.id)
          )
          ?.map((roleItem) => ({
            id: roleItem.id,
            name: roleItem.name,
          }))
      );
    } catch (err) {
      toast.error(strings.responses.errorFetch);
    }
  }

  useEffect(() => {
    setRolesGranted(initRolesGranted);
    fetchRolesAvailable(undefined, initRolesGranted);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initRolesGranted, resetValues]);

  useEffect(() => {
    if (onChangeRolesGranted) onChangeRolesGranted(rolesGranted);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rolesGranted]);

  const cleanSelected = () => {
    setRolesAvailableSelected([]);
    setRolesGrantedSelected([]);
  };

  const setInAvailable = (items) => {
    setRolesAvailable((prevSt) => [...prevSt, ...items]);
    setRolesGranted((prevSt) =>
      prevSt.filter((prev) => !items?.some((role) => role.id === prev.id))
    );
    cleanSelected();
  };

  const setInGranted = (items) => {
    setRolesGranted((prevSt) => [...prevSt, ...items]);
    setRolesAvailable((prevSt) =>
      prevSt.filter((prev) => !items?.some((role) => role.id === prev.id))
    );
    cleanSelected();
  };

  const onSearchRolesGranted = (keyword) => {
    setKeywordRolesGranted(keyword);
  };

  return (
    <Grid templateColumns={{ base: "1fr", large: "2fr 1fr 2fr" }} gap="30px">
      <div>
        <div className="fs-5 mb-3">{strings.roles.available}</div>
        <ItemListCollection
          items={rolesAvailable}
          selectedItems={rolesAvailableSelected}
          setSelectedItems={setRolesAvailableSelected}
          onSearchSubmit={(keyword) =>
            fetchRolesAvailable(keyword, rolesGranted)
          }
        />
      </div>
      <div style={styles.containerButtons}>
        <Button
          style={styles.buttonActions}
          onClick={() => setInAvailable(rolesGrantedSelected)}
        >
          <IoIosArrowBack />
        </Button>
        <Button
          style={styles.buttonActions}
          onClick={() => setInAvailable(rolesGranted)}
        >
          <IoIosArrowBack />
          <IoIosArrowBack />
        </Button>
        <Button
          style={styles.buttonActions}
          onClick={() => setInGranted(rolesAvailableSelected)}
        >
          <IoIosArrowForward />
        </Button>
        <Button
          style={styles.buttonActions}
          onClick={() => setInGranted(rolesAvailable)}
        >
          <IoIosArrowForward />
          <IoIosArrowForward />
        </Button>
      </div>
      <div>
        <div className="fs-5 mb-3">{strings.roles.granted}</div>
        <ItemListCollection
          items={
            keywordRolesGranted
              ? rolesGranted.filter((roleGr) =>
                  roleGr.name
                    .toLowerCase()
                    .includes(keywordRolesGranted?.toLowerCase())
                )
              : rolesGranted
          }
          selectedItems={rolesGrantedSelected}
          setSelectedItems={setRolesGrantedSelected}
          onSearchSubmit={onSearchRolesGranted}
        />
      </div>
    </Grid>
  );
};

const strings = new LocalizedStrings({
  es: {
    roles: {
      available: "Roles disponibles",
      granted: "Roles otorgados",
    },
    responses: {
      errorFetch: "Error al consultar rol",
    },
  },
});

const styles = {
  containerButtons: {
    display: "flex",
    justifyContent: "center",
    flexFlow: "column",
    gap: "10px",
  },
  buttonActions: {
    width: "65px",
    alignSelf: "center",
  },
};

export default RolesChoose;
